import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from '../index.css';

export interface ILabelProps {
  invalid?: boolean;
  children?: React.ReactNode;
}
export const Label = ({ invalid = false, children }: ILabelProps) => (
  <div {...mergeStyles(styles['label'], invalid && styles['label-invalid'])}>{children}</div>
);
